<template>
  <div>
    <!-- {{ presetItems }} -->
    {{ schema }}
    <!-- <v-form-component
      :key="formKey"
      :model="vModel"
      :vModel="vModel"
      :schema="schema"
    ></v-form-component> -->
  </div>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import axios from "axios";
// import func from "../../vue-temp/vue-editor-bridge";
// import lodash from "lodash";

import * as fun from "../plugins/common";
export default {
  components: {
    VFormComponent: () => import("./FormComponent.vue"),
    VLabelButton: () => import("./LabelButton.vue"),
    VDeleteButton: () => import("./DeleteButton.vue"),
    VMoveButton: () => import("./MoveButton.vue"),
    // VAddButton: () => import("./AddButton.vue"),
  },
  props: {
    presetObject: Object,
    vModel: Array,
    parModel: [Object, Array, String],
    parentModel: [Object, Array, String],
    formModel: [Object, Array, String],
    parObject: Object,
    parentObject: Object,
    parentSchema: Object,
    label: String,
    table_title: String,
    hideTitle: Boolean,
    hideToolbar: Boolean,
    itemAsHeader: String,
    schema: Object,
    k: String,
    vBind: Object,
    elevation: String,
    data_object: Object,
    parentKey: String,
    noDeleteFirst: Boolean,
    noDelete: Boolean,
    newValue: String,
    cols: String,
    dynamicLabel: String,
    collapsible: Boolean,
    expandedIndex: Array,
    toolBarControls: Array,
    editedFields: Array,
    item: String,
  },
  data() {
    return {
      dataReady: false,
      itemsKey: 0,

      presetItems: [],
    };
  },
  mounted() {
    var that = this;
    //   var data = {
    // object_name: "document",
    // qry: {
    //   $or: [{ company: companyId }, { company: null }],
    // },

    axios
      .post(this.serverURL + "/get_data", this.presetObject, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response.data);
        this.presetItems = response.data.model;
        this.dataReady = true;
        // this.populateLettersMenu(response.data.model);
      });
  },
  methods: {
    customBtnClick(id) {
      console.log(id);
      this.$root.$emit("customBtnClick", {
        tbl: this,
        btn: id,
      });
      event.stopPropagation();
    },
    expandItem(index) {
      if (this.expandedItems.includes(index)) {
        this.expandedItems = this.expandedItems.filter((e) => {
          return e != index;
        });
      } else {
        this.expandedItems.push(index);
      }
    },
    sortItems(sort) {
      this.vModel.sort((a, b) => {
        return a[sort] - b[sort];
      });
    },

    capitalize(t) {
      return fun.capitalize(t);
    },
    getHeaderColor(item) {
      var key = this.getTitle(item);
      var headerColor = this.data_object.schema.headerColor;
      return headerColor ? this.getColor(headerColor, key) : "";
    },
    getColor(color, key) {
      try {
        return eval(color);
      } catch (error) {
        return "#000";
      }
    },
    getTitle(item) {
      return item[this.nameKey];
    },
    getSchema() {
      var s = this.schema;
      if (this.parentKey && this.parentKey) {
        s = this.parentSchema[this.parentKey].properties;
      }
      return s;
    },
  },
  watch: {
    vModel: {
      handler: function(newValue, oldValue) {
        this.$emit("input", this.vModel);
      },
      deep: true,
    },
  },
  computed: {
    nameKey() {
      var s = this.getSchema();
      return s[this.k]["name_key"];
    },
    addBtnTitle() {
      var s = this.getSchema();
      return s[this.k]["add_btn_title"];
    },
  },
};
</script>
<style>
.item {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
